<template>
  <div id="SectionGovernance">
    <UIContainer class="SectionGovernance__container">
      <template #left>
        <img
          class="SectionGovernance__image"
          :src="governanceImage"
          alt="Governance & Controls (Factors, Scope 2, Evidence Vault)"
          loading="lazy"
        />
      </template>

      <template #right>
        <div class="SectionGovernance__content">
          <SectionTitle titleSize="sm">
            <template #title>
              Governance & Controls<br />
              (Factors, Scope 2, Evidence Vault)
            </template>

            <template #description>
              Prevent restatements. Apply correct RECs/GOs logic, vintages, and
              geography; keep a one-click audit trail.
            </template>
          </SectionTitle>

          <div class="SectionGovernance__features">
            <div
              class="SectionGovernance__feature"
              v-for="feature in features"
              :key="feature"
            >
              <UIIcon
                class="SectionGovernance__feature-icon"
                name="checkCircleOutline"
              />
              <span>{{ feature }}</span>
            </div>
          </div>

          <!--<div class="SectionGovernance__cta">
            <UIButton size="xl" theme="primary" buttonStyle="pale">
              Learn more

              <template #icon-after>
                <UIIcon name="arrowLink" />
              </template>
            </UIButton>
          </div>-->
        </div>
      </template>
    </UIContainer>
  </div>
</template>

<script setup lang="ts">
import SectionTitle from '@/views/components/misc/SectionTitle.vue'
// import UIButton from '@/views/components/ui/buttons/UIButton.vue'
import UIContainer from '@/views/components/ui/containers/UIContainer/UIContainer.vue'
import UIIcon from '@/views/components/ui/icons/UIIcon.vue'
import governanceImage from '../assets/governance/governance.avif'

const features = [
  'Versioned factor library (EEA/eGRID/SmartWay/EPDs)',
  'Scope 2 dual-reporting with residual mix',
  'Certificate validation',
  'Evidence vault',
  'Sampling exports',
]
</script>

<style lang="scss" scoped>
#SectionGovernance {
  position: relative;

  :deep(.UIContainer__left) {
    display: flex;
    justify-content: flex-end;
  }

  .SectionGovernance__container {
    padding-top: 0;
    padding-bottom: 0;
  }

  .SectionGovernance__image {
    display: none;

    .FramedImage {
      position: absolute;
      right: 0;
      padding: 3.5rem 0;
    }

    @include md {
      display: block;
    }
  }

  .SectionGovernance__content {
    padding: 1rem 0;
    @include md {
      margin-left: 6rem;
    }
  }

  .SectionGovernance__title {
    @include font-size-20px();
    font-weight: 600;
    line-height: 1.2;
    color: $color-ui-gray-cool-900;
    margin-bottom: 1rem;

    @include md {
      @include font-size-24px();
    }
  }

  .SectionGovernance__features {
    display: grid;
    gap: 1.25rem;
    padding-left: 1rem;
    margin-top: 2rem;
    margin-bottom: 2rem;
  }

  .SectionGovernance__feature {
    @include font-size-18px();
    display: flex;
    align-items: center;
    color: $color-ui-gray-cool-600;
    gap: 0.75rem;
  }

  .SectionGovernance__feature-icon {
    --size: 1.75rem;
  }

  .SectionGovernance__cta {
    display: flex;
    align-items: center;
    gap: 1rem;
  }
}
</style>
